import type { BillingCycle, SubscriptionPlan } from '@billx/types';

export interface CheckLimitResult {
  allowed: boolean;
  current: number;
  limit: number;
  usagePercentage: number;
  isUnlimited: boolean;
}

export const getPlanDisplayPrice = (
  plan: SubscriptionPlan,
  billingCycle?: BillingCycle
): string => {
  if (plan.price === 0) return 'Free';

  if (billingCycle === 'yearly') {
    return `₹${plan.price}`;
  }

  return `₹${plan.price}`;
};

export const getPlanSavings = (
  plans: SubscriptionPlan[],
  plan: SubscriptionPlan
): number => {
  const monthlyTotal =
    (plans.find((p) => p.billingCycle === 'monthly' && p.tier === plan.tier)
      ?.price ?? 0) * 12;
  const yearlyPrice = plan.price;
  const savings = monthlyTotal - yearlyPrice;
  return Math.round((savings / monthlyTotal) * 100);
};

export const calculateRemainingDays = (periodEnd: string) => {
  return Math.max(
    0,
    Math.ceil(
      (new Date(periodEnd).getTime() - Date.now()) / (1000 * 60 * 60 * 24)
    )
  );
};
